module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (obj.isLoading()) { 
__p+='\n\n  <td colspan="100">\n    <div class="m-list-loader__inner">\n      <div class="m-list-loader__container">\n        <div class="m-loader"></div>\n      </div>\n    </div>\n  </td>\n\n';
 } else { 
__p+='\n  <td colspan="100">\n    <div class="m-list-empty__inner">\n      <div class="empty-indicator">\n        <div class="empty-indicator__icon"></div>\n          <h2>'+
((__t=( obj.getTitle() ))==null?'':__t)+
'</h2>\n          <p>'+
((__t=( obj.getSubTitle() ))==null?'':__t)+
'</p>\n        </div>\n      </div>\n    </div>\n\n  </td>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/list-view/templates/empty.html
// module id = 408
// module chunks = 0